export var DIALOG_WIDTH = 310;
export var DIALOG_WIDTH_WIDER = 325;
export var VIEW_HEIGHT = 305;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/pickers/esm/constants/dimensions.js
// module id = 359
// module chunks = 0